export default __webpack_public_path__ + "static/media/coiled.11cd2262.jpeg";